// extracted by mini-css-extract-plugin
module.exports = {"bookCover":"style_bookCover__EKwKC","cornerBadge":"style_cornerBadge__PfuC8","bottomPart":"style_bottomPart__dH9vV"};